// 账户管理
import request from "@/utils/request";

// 用户列表
export function usersList(data) {
  return request({
    url: "/merchant/merchantUserManager/pageList",
    method: "post",
    data
  });
}

export function addExistedUser(data) {
  return request({
    url: "/merchant/merchantUserManager/addExistedUser",
    method: "post",
    data
  });
}

export function addUser(data) {
  return request({
    url: "/merchant/merchantUserManager/addUser",
    method: "post",
    data
  });
}

export function editUser(data) {
  return request({
    url: "/merchant/merchantUserManager/editUser",
    method: "post",
    data
  });
}

export function deleteMerchantUser(data) {
  return request({
    url: "/merchant/merchantUserManager/deleteMerchantUser",
    method: "post",
    data
  });
}

export function usersStatus(data) {
  return request({
    url: "/merchant/merchantUserManager/merchantUserStatusOperate",
    method: "post",
    data
  });
}

// 查询用户权限
export function merchantRole(data) {
  return request({
    url: "/merchant/merchantPowerManager/details",
    method: "post",
    data
  });
}

export function editRole(data) {
  return request({
    url: "/merchant/merchantPowerManager/editMerchantMenuPower",
    method: "post",
    data
  });
}

export function selectRelTaxList(data) {
  return request({
    url: "/merchant/merchant/rel/tax/list",
    method: "get",
    params: data
  });
}

export const getSystemTimestamp = () => {
  return request({
    url: "/merchant/common/system/timestamp",
    method: "get",
    skipSign: true
  });
};
